'use client';

import React from 'react';

interface PreviewYoYRowProps {
  pctChange: number;
  isNew: boolean;
  codeSetLabel: string;
}

const PreviewYoYRow: React.FC<PreviewYoYRowProps> = ({
  pctChange,
  isNew,
  codeSetLabel,
}) => {
  const isPositive = isNew || pctChange > 0;
  const isNegative = pctChange < 0;

  const arrowColor = isPositive
    ? 'text-green-600'
    : isNegative
      ? 'text-red-600'
      : 'text-neutral-500';

  const arrow = isPositive ? '▲' : isNegative ? '▼' : '—';

  const pctDisplay = isNew ? 'New' : `${Math.abs(pctChange)}%`;

  const directionLabel = isNew
    ? 'New'
    : isPositive
      ? `Up ${Math.abs(pctChange)}%`
      : isNegative
        ? `Down ${Math.abs(pctChange)}%`
        : 'No change';

  return (
    <div className="flex items-center gap-2" data-testid="preview-yoy-row">
      <span className="sr-only">{directionLabel}</span>
      <span
        className={`text-sm font-semibold shrink-0 ${arrowColor}`}
        data-testid="preview-yoy-row-arrow"
        aria-hidden="true"
      >
        {arrow}
      </span>
      <span
        className={`text-sm font-semibold tabular-nums shrink-0 ${arrowColor}`}
        data-testid="preview-yoy-row-percentage"
        aria-hidden="true"
      >
        {pctDisplay}
      </span>
      <span
        className="text-xs text-neutral-600 truncate"
        data-testid="preview-yoy-row-label"
      >
        {codeSetLabel}
      </span>
    </div>
  );
};

export default PreviewYoYRow;
